import script from "./Image-wap.vue?vue&type=script&lang=ts&setup=true"
export * from "./Image-wap.vue?vue&type=script&lang=ts&setup=true"

import "./Image-wap.vue?vue&type=style&index=0&id=1379c91e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1379c91e"]])

export default __exports__